import { Notifications } from 'feature/notifications'
import { MainLayout } from 'layouts'

export const NoticePage = () => {
  return (
    <MainLayout>
      <div className='container'>
        <Notifications />
      </div>
    </MainLayout>
  )
}
